import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=0210be56&scoped=true"
import script from "./exercise.vue?vue&type=script&lang=js"
export * from "./exercise.vue?vue&type=script&lang=js"
import style0 from "./exercise.vue?vue&type=style&index=0&id=0210be56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210be56",
  null
  
)

export default component.exports